module.exports = __webpack_public_path__ + "img/1566.18ccfc6b.gif";